import MuiAccordion from './MuiAccordion';
import MuiAppBar from './MuiAppBar';
import MuiButton from './MuiButton';
import MuiCssBaseline from './MuiCssBaseline';
import MuiToolbar from './MuiToolbar';
import MuiList from './MuiList';
import MuiMenuItem from './MuiMenuItem';
import MuiStack from './MuiStack';

const components = {
  MuiAccordion,
  MuiAppBar,
  MuiCssBaseline,
  MuiButton,
  MuiMenuItem,
  MuiList,
  MuiToolbar,
  MuiStack,
};

export default components;
